import Vue from 'vue'

export default async (coupon_code) => {
  let data = {
    code: coupon_code
  }
  let res = await Vue.axios.post(`/billing/apply_coupon`, data)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/apply-coupon-code.js